import React, { useEffect, useState } from 'react';
import { getActebi, getActebiCategory } from '../../service/service';
import { Link, useParams } from 'react-router-dom';

export default function ActebiList() {
	const [list, setList] = useState([]);
	const { slug } = useParams();

	useEffect(() => {
		const getList = async () => {
			await getActebiCategory().then(item => {
				setList(item);
			});
		};
		getList();
	}, []);

	return (
		<>
			{list?.map(item => (
				<span key={item.id} className={item.slug === slug ? 'active' : ''}>
					<Link
						to={
							item.slug === 'komisiebis-skhdomis-oqmebi'
								? `/komisiebis-skhdomis-oqmebi/${item.slug}`
								: `/sakrebulo/${item.slug}`
						}
					>
						{item.title}
					</Link>
				</span>
			))}
		</>
	);
}
